import React, { useState, useEffect } from "react";
import axios from "axios";
import "./MarketStatus.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const BankNiftyMarket = () => {
    const [companies, setCompanies] = useState([]);
    const [activeTab, setActiveTab] = useState("marketStatus");
    const [loading, setLoading] = useState(true);

    // --- State for Market Status Modal ---
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [statusCounts, setStatusCounts] = useState({ bullish: 0, bearish: 0 });
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [latestUpdate, setLatestUpdate] = useState(null);
    // --- State for Live BB Confirmation Modal ---
    const [showLiveBBConfirmation, setShowLiveBBConfirmation] = useState(false);
    const [pendingLiveBB, setPendingLiveBB] = useState([]); // Stores stocks for the modal
    useEffect(() => {
        if (activeTab === "liveBB") {
            setCompanies(prev =>
                prev.map(c => ({
                    ...c,
                    liveBB: false // reset all checkboxes
                }))
            );
        }
    }, [activeTab]);

    useEffect(() => {
        const fetchCompanies = async () => {
            setLoading(true);
            try {
                const response = await fetch("https://prod-erp.nifty10.in/bank-nifty/companies");
                const result = await response.json();
                const companyList = Array.isArray(result) ? result : result.data || [];

                const formattedCompanies = companyList.map((c) => ({
                    ...c,
                    companyStatus: c.companyStatus || "BULLISH",
                    liveBB: !!c.liveBB,
                }));

                setCompanies(formattedCompanies);

                // 🌟 Auto-select the first company
                if (formattedCompanies.length > 0) {
                    const firstCompany = formattedCompanies[0];
                    setSelectedCompany(firstCompany);

                    if (firstCompany.updateLogs && firstCompany.updateLogs.length > 0) {
                        const latest = firstCompany.updateLogs.reduce((a, b) =>
                            new Date(a.updatedDate) > new Date(b.updatedDate) ? a : b
                        );
                        setLatestUpdate(latest.updatedDate);
                    } else {
                        setLatestUpdate(null);
                    }
                }
            } catch (error) {
                console.error("Error fetching companies:", error);
                setCompanies([]);
            } finally {
                setLoading(false);
            }
        };

        fetchCompanies();
    }, []);

    // when a company is clicked, set selectedCompany + compute latest log
    const handleSelectCompany = (company) => {
        setSelectedCompany(company);

        if (company.updateLogs && company.updateLogs.length > 0) {
            const latest = company.updateLogs.reduce((a, b) =>
                new Date(a.updatedDate) > new Date(b.updatedDate) ? a : b
            );
            setLatestUpdate(latest.updatedDate);
        } else {
            setLatestUpdate(null);
        }
    };

    const formatUTCDate = (utcDateStr) => {
  if (!utcDateStr) return "-";
  const date = new Date(utcDateStr);
  const day = date.getUTCDate().toString().padStart(2, "0");
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const year = date.getUTCFullYear();
  const hours = date.getUTCHours().toString().padStart(2, "0");
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");
  return `${day}-${month}-${year} ${hours}:${minutes}`;
};



    const handleStatusChange = (companyId, status) => {
        setCompanies((prev) =>
            prev.map((c) => (c.companyId === companyId ? { ...c, companyStatus: status } : c))
        );
    };
    const handleLiveBBChange = (companyId) => {
        setCompanies((prevCompanies) => {
            const clickedCompany = prevCompanies.find(c => c.companyId === companyId);

            return prevCompanies.map((company) => {
                if (company.companyId === companyId) {
                    // Toggle clicked checkbox
                    return { ...company, liveBB: !company.liveBB };
                }

                // Uncheck any other company with the same status
                if (clickedCompany && company.companyStatus === clickedCompany.companyStatus) {
                    return { ...company, liveBB: false };
                }

                return company;
            });
        });
    };


    const handleMarketStatusSubmit = (e) => {
        e.preventDefault();
        const bullish = companies.filter(c => c.companyStatus === "BULLISH").length;
        const bearish = companies.filter(c => c.companyStatus === "BEARISH").length;
        setStatusCounts({ bullish, bearish });
        setShowConfirmation(true);
    };

    const handleLiveBBSubmit = (e) => {
        e.preventDefault();
        const selected = companies.filter(c => c.liveBB);
        setPendingLiveBB(selected);
        setShowLiveBBConfirmation(true);
    };

    const proceedMarketStatusUpdate = async () => {
        
        try {
            const payload = companies.map(c => ({
                companyId: c.companyId,
                companyStatus: c.companyStatus,
                liveBB: c.liveBB
            }));

            // Store payload in localStorage instead of sending to API
            localStorage.setItem("marketStatusData", JSON.stringify(payload));

            toast.success("Market status saved locally!", {
                position: "top-right",
            });
            setShowConfirmation(false);
        } catch (error) {
            console.error("Error saving market status:", error);
            alert("Failed to save market status locally.");
        }
    };


    const proceedLiveBBUpdate = async () => {
        

        try {
            const payload = companies.map(c => ({
                companyId: c.companyId,
                companyStatus: c.companyStatus,
                liveBB: c.liveBB
            }));

            await axios.put(
                "https://prod-erp.nifty10.in/bank-nifty/company/bulk/update",
                payload,
                { headers: { "Content-Type": "application/json" } }
            );
            toast.success("Live BB status updated successfully!", {
                position: "top-right",
            });
            setShowLiveBBConfirmation(false);
        } catch (err) {
            console.error("Live BB update failed:", err);
            alert("Failed to update Live BB.");
        }
    };

    const getSelectedBBStocksGrouped = () => {
        const bullish = pendingLiveBB.filter(c => c.companyStatus === "BULLISH").map(c => c.companyName);
        const bearish = pendingLiveBB.filter(c => c.companyStatus === "BEARISH").map(c => c.companyName);
        return { bullish, bearish };
    };

    if (loading) return <div className="loading-container"><p className="loading-user-data">Loading companies...</p></div>;
    if (companies.length === 0) return <p>No companies found</p>;

    return (
        <div id="marketStatusContainer" className="bank-market-status-container">
            {/* Tabs */}
            <div className="tabs-header">
                <div className="tabs-container">
                    <button
                        className={`tab-btn ${activeTab === "marketStatus" ? "active" : ""}`}
                        onClick={() => setActiveTab("marketStatus")}
                    >
                        Market Status
                    </button>
                    <button
                        className={`tab-btn ${activeTab === "liveBB" ? "active" : ""}`}
                        onClick={() => setActiveTab("liveBB")}
                    >
                        Live BB
                    </button>
                </div>

                {selectedCompany && (
                    <div className="latest-update-info">
                        <span className="latest-update" style={{ fontWeight: 600 }}>
                            Latest Update: {formatUTCDate(latestUpdate)}
                        </span>
                        
                    </div>
                )}
            </div>


            {/* Market Status Content */}
            {activeTab === "marketStatus" && (
                <form onSubmit={handleMarketStatusSubmit} id="marketStatusForm">
                    <div className="bank-company-grid">
                        {companies.map((company) => (
                            <div key={company.companyId} className="bank-company-item">
                                <span className="bank-company-name">{company.companyName}</span>
                                <div className="bank-radio-group">
                                    <input
                                        type="radio"
                                        id={`${company.companyId}-bullish`}
                                        name={company.companyId}
                                        value="BULLISH"
                                        checked={company.companyStatus === "BULLISH"}
                                        onChange={() => handleStatusChange(company.companyId, "BULLISH")}
                                    />
                                    <label htmlFor={`${company.companyId}-bullish`} className="bank-bullish-label">Bullish</label>
                                    <input
                                        type="radio"
                                        id={`${company.companyId}-bearish`}
                                        name={company.companyId}
                                        value="BEARISH"
                                        checked={company.companyStatus === "BEARISH"}
                                        onChange={() => handleStatusChange(company.companyId, "BEARISH")}
                                    />
                                    <label htmlFor={`${company.companyId}-bearish`} className="bank-bearish-label">Bearish</label>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="bank-submit-btn-container">
                        <button type="submit" className="bank-submit-btn">Submit</button>
                    </div>
                </form>
            )}

            {/* Live BB Content */}
            {activeTab === "liveBB" && (
                <form onSubmit={handleLiveBBSubmit} id="liveBBForm">
                    <div className="bank-company-grid">
                        {companies.map((company) => (
                            <div key={company.companyId} className="bank-company-item">
                                <input
                                    type="checkbox"
                                    className="livebb-check"
                                    id={`${company.companyId}-cb`}
                                    checked={company.liveBB}
                                    onChange={() => handleLiveBBChange(company.companyId)}
                                    style={{ marginLeft: "20px" }}
                                />
                                <span className="bank-company-name">{company.companyName}</span>
                                <span
                                    className={`status-tag ${company.companyStatus === "BULLISH" ? "bullish" : "bearish"}`}
                                    style={{
                                        backgroundColor: company.companyStatus === "BULLISH" ? "#16a34a" : "#dc2626",
                                        color: "#fff",
                                        borderRadius: "20px",
                                        padding: "8px 12px",
                                        marginLeft: "10px",
                                    }}
                                >
                                    {company.companyStatus}
                                </span>
                            </div>
                        ))}
                    </div>
                    <div className="bank-submit-btn-container">
                        <button type="submit" className="bank-submit-btn">Submit</button>
                    </div>
                </form>
            )}

            {/* Market Status Confirmation Modal */}
            {showConfirmation && (
                <div className="confirmation-modal-overlay">
                    <div className="confirmation-modal">
                        <div className="modal-icon">⚠️</div>
                        <h3>Confirm Market Status Change</h3>
                        <div className="popup-status-counts">
                            <span className="popup-count bullish-count">Bullish: {statusCounts.bullish}</span>
                            <span className="popup-count bearish-count">Bearish: {statusCounts.bearish}</span>
                        </div>
                        <div className="modal-actions">
                            <button className="no-btn" onClick={() => setShowConfirmation(false)}>Cancel</button>
                            <button className="yes-btn" onClick={proceedMarketStatusUpdate}>Confirm</button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODIFIED: Live BB Confirmation Modal */}
            {showLiveBBConfirmation && (
                <div className="confirmation-modal-overlay">
                    <div className="confirmation-modal">
                        <div className="modal-icon">⚠️</div>
                        <p style={{ fontWeight: "bold", marginTop: "10px" }}>Selected BB Stocks</p>
                        {(() => {
                            const { bullish, bearish } = getSelectedBBStocksGrouped();
                            return (
                                <div className="bb-stocks-list">
                                    {bullish.length > 0 && (
                                        <div>
                                            <h4 style={{ color: "#146c2d" }}>Bullish</h4>
                                            <div className="bank-stock-grid">
                                                {bullish.map((name, i) => (
                                                    <span key={i} className="bank-stock-pill">{name}</span>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {bearish.length > 0 && (
                                        <div style={{ marginTop: "12px" }}>
                                            <h4 style={{ color: "#b30000" }}>Bearish</h4>
                                            <div className="bank-stock-grid">
                                                {bearish.map((name, i) => (
                                                    <span key={i} className="bank-stock-pill">{name}</span>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {bullish.length === 0 && bearish.length === 0 && (
                                        <p>No stocks selected.</p>
                                    )}
                                </div>
                            );
                        })()}
                        <div className="modal-actions">
                            <button className="no-btn" onClick={() => setShowLiveBBConfirmation(false)}>No</button>
                            <button className="yes-btn" onClick={proceedLiveBBUpdate}>Yes</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BankNiftyMarket;